import React from 'react';

import SvgIcon from '../../../../SvgIcon/SvgIcon';

import POSSelectField from '../../../../POS/Fields/POSSelectField';
import POSInputField from '../../../../POS/Fields/POSInputField';
import POSDateField from '../../../../POS/Fields/POSDateField';

import useQuotationPaymentCondition from '../../../../../hooks/sale/useQuotationPaymentCondition';

const QuotationPaymentConditionSection: React.FC = () => {
  const {
    form,
    paymentCondition,
    paymentConditionDropdown,
    termDropdown,
    isCredit,
    termCode,
    handlePaymentConditionChange,
    handleTermChange,
    handleCreditDaysChange,
    handleCreditMonthsChange,
    handleCreditYearsChange,
    handleCreditDueDateChange,
  } = useQuotationPaymentCondition();

  // =====================================================
  // 🔹 Sin cotización activa
  // =====================================================
  if (!form?.id) {
    return null;
  }

  return (
    <div className="flex flex-col gap-5">
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <div className="flex items-start gap-3 sm:items-center">
        <div
          className="
            flex h-11 w-11 shrink-0 items-center justify-center
            rounded-xl border border-primary/15 bg-primary/10 text-primary
          "
        >
          <SvgIcon name="credit-card" />
        </div>

        <div>
          <h3 className="text-base font-semibold text-black dark:text-white">
            Condición de pago
          </h3>

          <p className="mt-1 text-sm text-body">
            Define la forma de pago y, si es a crédito, el plazo de esta
            cotización.
          </p>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}

      <div className="flex flex-col gap-3 md:flex-row md:items-end">
        <div className="min-w-0 md:flex-1">
          <POSSelectField
            label="Forma de pago"
            name="paymentCondition"
            iconKey="creditCard"
            value={paymentCondition?.id || ''}
            placeholder="Seleccionar condición"
            options={paymentConditionDropdown.map((item: any) => ({
              value: item.id,
              label: item.name,
            }))}
            onChange={(e: any) =>
              handlePaymentConditionChange(e.target.value)
            }
          />
        </div>

        {isCredit && (
          <div className="min-w-0 md:flex-1">
            <POSSelectField
              label="Unidad del plazo"
              name="term"
              iconKey="calendar"
              value={paymentCondition?.termId || ''}
              placeholder="Seleccionar plazo"
              options={termDropdown.map((item: any) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(e: any) => handleTermChange(e.target.value)}
            />
          </div>
        )}

        {isCredit && termCode === '01' && (
          <div className="min-w-0 md:w-[160px]">
            <POSInputField
              name="creditDays"
              label="Días de crédito"
              type="number"
              min={0}
              placeholder="Ej: 30"
              icon="calendar"
              value={paymentCondition?.creditDays ?? ''}
              onChange={(e: any) => handleCreditDaysChange(e.target.value)}
            />
          </div>
        )}

        {isCredit && termCode === '02' && (
          <div className="min-w-0 md:w-[160px]">
            <POSInputField
              name="creditMonths"
              label="Meses de crédito"
              type="number"
              min={0}
              placeholder="Ej: 2"
              icon="calendar"
              value={paymentCondition?.creditMonths ?? ''}
              onChange={(e: any) => handleCreditMonthsChange(e.target.value)}
            />
          </div>
        )}

        {isCredit && termCode === '03' && (
          <div className="min-w-0 md:w-[160px]">
            <POSInputField
              name="creditYears"
              label="Años de crédito"
              type="number"
              min={0}
              placeholder="Ej: 1"
              icon="calendar"
              value={paymentCondition?.creditYears ?? ''}
              onChange={(e: any) => handleCreditYearsChange(e.target.value)}
            />
          </div>
        )}

        {isCredit && (
          <div className="min-w-0 md:w-[200px]">
            <POSDateField
              label="Fecha límite"
              name="creditDueDate"
              iconKey="calendar"
              value={paymentCondition?.creditDueDate || ''}
              onChange={(date: string) => handleCreditDueDateChange(date)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuotationPaymentConditionSection;
